import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    ns: ['common'],
    defaultNS: 'common',
    fallbackLng: ['en', 'fr', 'it', 'es', 'jp'],
    supportedLngs: ['en', 'fr', 'it', 'es', 'jp'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
    load: 'languageOnly',
  });

export default i18next;
